var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricShutters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 12.75,
    width: 5,
    height: 4.5,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 2.75,
    width: 20.5,
    height: 9.5,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 5.75,
    width: 20.5,
    height: 3.5,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 12.75,
    width: 18.5,
    height: 7.5,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 12.75,
    width: 5,
    height: 4.5,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricShutters);
export default __webpack_public_path__ + "static/media/electric_shutters.1e8c644e7630f2009ccd31ff8346c6ef.svg";
export { ForwardRef as ReactComponent };